import type { SocialButtonProps, SocialIdPHandler } from 'app/components/authentication/LoginButtonState';
import { SocialAuthButton } from './SocialAuthButton';
import { log, recordError } from 'app/lib/monitoring';
import { getFacebookIdentity } from 'app/network/identity';
import * as WebBrowser from 'expo-web-browser';
import * as AuthSession from 'expo-auth-session';
import * as Facebook from 'expo-auth-session/providers/facebook';
import { isMobileNative } from 'app/utils/web-helpers';
import { env } from 'app/lib/env';

WebBrowser.maybeCompleteAuthSession();

async function handleFacebookRequest(
  authResult: AuthSession.AuthSessionResult | null,
  handleSocialIdP: SocialIdPHandler,
  setButtonState: (value: boolean) => void,
) {
  try {
    if (authResult?.type === 'success' && authResult.authentication) {
      const { accessToken } = authResult.authentication;
      const me = await getFacebookIdentity(accessToken);
      handleSocialIdP({
        email: me.email,
        token: accessToken,
        provider: 'Facebook',
        onError: () => {
          if (Facebook.discovery.revocationEndpoint) {
            AuthSession.revokeAsync({ token: accessToken }, Facebook.discovery).catch((err: unknown) =>
              recordError(err),
            );
          }
        },
      });
    } else {
      log('Facebook login cancelled');
      setButtonState(false);
    }
  } catch (error) {
    log('Facebook login error:', error);
    setButtonState(false);
  }
}

export function FacebookLoginButton({ handleSocialIdP, loginButtonsState, iconOnly }: SocialButtonProps) {
  const { setLoginButton } = loginButtonsState;

  const redirectUri = AuthSession.makeRedirectUri({
    scheme: env.BUNDLE_ID,
    preferLocalhost: false,
  });

  const [, , promptAsync] = Facebook.useAuthRequest({
    clientId: '589662519600530',
    scopes: ['public_profile', 'email'],
    redirectUri: !isMobileNative ? redirectUri : undefined,
  });

  const toggleButtonStateToBe = (toState: boolean) => {
    setLoginButton('Facebook', toState);
  };

  const onFacebookRequestHandler = (authResult: AuthSession.AuthSessionResult | null) =>
    handleFacebookRequest(authResult, handleSocialIdP, toggleButtonStateToBe);

  return (
    <SocialAuthButton
      iconOnly={iconOnly}
      loginButtonsState={loginButtonsState}
      onPress={() => {
        toggleButtonStateToBe(true);
        void promptAsync()
          .then(onFacebookRequestHandler)
          .catch((error: unknown) => {
            log('Facebook login prompt error:', error);
            toggleButtonStateToBe(false);
          });
      }}
      provider="Facebook"
    />
  );
}
